import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import InputContainer from './InputContainer';
import Errors from './Errors';

export const TextInput = styled('input')`
    //Pseudo-Resets
    &[type='number'] {
      appearance: textfield;
  
      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        appearance: none;
        margin: 0;
      }
    }
    
    &::-ms-clear, &::-ms-reveal {
      display: none;
    }
`;

const Input = ({ errors, inputRef, showTextErrors, placeholder, maxWidth, ...props }) => (
  <InputContainer errors={errors} disabled={props.disabled} maxWidth={maxWidth} >
    <TextInput
      {...props}
      ref={inputRef}
      value={(props.value && !props.disabled) ? props.value : ''}
      placeholder={props.disabled ? '' : placeholder}
    />
    {showTextErrors && <Errors errors={errors} />}
  </InputContainer>
);

Input.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  inputRef: PropTypes.shape(),
  type: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  maxLength: PropTypes.number,
  maxWidth: PropTypes.string,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  onPaste: PropTypes.func,
  showTextErrors: PropTypes.bool,
  errors: PropTypes.array,
};

Input.defaultProps = {
  value: '',
  placeholder: '',
  inputRef: null,
  type: 'text',
  id: null,
  disabled: false,
  maxLength: null,
  maxWidth: '100%',
  onChange: () => {},
  onKeyUp: () => {},
  onBlur: () => {},
  onPaste: () => {},
  showTextErrors: true,
  errors: null,
};

export default Input;
